import _ from "lodash";

const getDefaultCycle = (cycleList) => {
  let sortedCycleList;

  const futureCycles = _.filter(cycleList, (cycle) => {
    return new Date(cycle.final_date) > new Date();
  });

  if (_.isEmpty(futureCycles)) {
    sortedCycleList = _.orderBy(
      cycleList,
      (cycle) => {
        return new Date(cycle.final_date);
      },
      "desc"
    );
  } else {
    sortedCycleList = _.orderBy(
      futureCycles,
      (cycle) => {
        return new Date(cycle.final_date);
      },
      "asc"
    );
  }

  return sortedCycleList[0].id;
};
export const getCycleTypeId = (label, cycleSlice) => {
  const cycleTypeId = _.filter(cycleSlice.type, (cycle) => {
    return cycle.label === label;
  });

  return cycleTypeId;
};

export const isCycleTypeById = (cycleTypeId, cycleSlice) => {
  return _.find(cycleSlice.type, { id: cycleTypeId }).label;
};

export const getPathnameByCycletype = (cycleType, url) => {
  let scenarioPath;
  switch (cycleType) {
    case "Trade Promotions":
      scenarioPath = `${url}`;
      break;
    case "Daily Trade Promotions":
      scenarioPath = `${url}`;
      break;
    default:
      scenarioPath = `${url}/pricing`;
      break;
  }
  return scenarioPath;
};

export const getCycleLabel = (cycleTypeId) => {
  let cycleLabel;
  switch (cycleTypeId) {
    case 1:
      cycleLabel = "Pricing";
      break;
    case 3:
      cycleLabel = "Pricing 2.0";
      break;
    case 4:
      cycleLabel = "Daily Trade Promotions";
      break;
    default:
      cycleLabel = "Trade Promotions";
      break;
  }
  return cycleLabel;
};

export default getDefaultCycle;
